export const getThemeMode = (state) => state.theme.themeMode;
export const getLanguage = (state) => state.theme.language;
